import { useTranslation } from 'react-i18next'

const footerLinkKeys = ['privacy', 'terms', 'archive', 'contact'] as const

export type FooterLinkKey = (typeof footerLinkKeys)[number]

type FooterProps = {
  disabledLinks?: FooterLinkKey[]
}

export function Footer({ disabledLinks = [] }: FooterProps) {
  const { t } = useTranslation()
  const disabledLinkSet = new Set<FooterLinkKey>(disabledLinks)

  return (
    <footer
      id="about"
      className="border-t border-[var(--color-outline-variant)]/70 px-5 py-7 md:px-8"
    >
      <div className="mx-auto flex w-full max-w-[1280px] flex-col gap-5 md:flex-row md:items-center md:justify-between">
        <p className="text-[10px] font-medium uppercase tracking-[0.2em] text-[var(--color-on-surface-variant)]/80">
          {t('layout.footer.copyright')}
        </p>

        <div className="flex flex-wrap items-center gap-5 md:gap-8">
          {footerLinkKeys.map((linkKey) => (
            disabledLinkSet.has(linkKey) ? (
              <span
                key={linkKey}
                aria-disabled="true"
                className="cursor-not-allowed text-[10px] font-medium uppercase tracking-[0.18em] text-[var(--color-label-disabled)]"
              >
                {t(`layout.footer.${linkKey}`)}
              </span>
            ) : (
              <a
                key={linkKey}
                href="#top"
                className="text-[10px] font-medium uppercase tracking-[0.18em] text-[var(--color-on-surface-variant)]/75 transition-colors hover:text-[var(--color-on-surface)]"
              >
                {t(`layout.footer.${linkKey}`)}
              </a>
            )
          ))}
        </div>
      </div>
    </footer>
  )
}
